/**
 * Clickable FAQ/Q&A media thumbnails (.page-qa__media) open in a simple lightbox.
 */
const OVERLAY_ID = 'page-qa-media-overlay';

function ensureOverlay() {
    let overlay = document.getElementById(OVERLAY_ID);

    if (overlay) {
        return overlay;
    }

    overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'page-qa-media-overlay hidden';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = [
        '<button type="button" class="page-qa-media-overlay__close" aria-label="Close">&times;</button>',
        '<div class="page-qa-media-overlay__body"></div>',
    ].join('');

    document.body.appendChild(overlay);

    overlay.querySelector('.page-qa-media-overlay__close').addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
            closeOverlay();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !overlay.classList.contains('hidden')) {
            closeOverlay();
        }
    });

    return overlay;
}

function closeOverlay() {
    const overlay = document.getElementById(OVERLAY_ID);

    if (!overlay) {
        return;
    }

    const body = overlay.querySelector('.page-qa-media-overlay__body');
    const video = body ? body.querySelector('video') : null;

    if (video) {
        video.pause();
    }

    if (body) {
        body.innerHTML = '';
    }

    overlay.classList.add('hidden');
    document.body.classList.remove('page-qa-media-open');
}

function withYoutubeAutoplay(url) {
    if (!url || url.indexOf('youtube.com/embed') === -1) {
        return url;
    }

    try {
        const parsed = new URL(url);
        parsed.searchParams.set('autoplay', '1');
        return parsed.toString();
    } catch (e) {
        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1';
    }
}

function openMedia(link) {
    const type = link.getAttribute('data-qa-media') || 'image';
    const href = link.getAttribute('href');

    if (!href) {
        return;
    }

    const overlay = ensureOverlay();
    const body = overlay.querySelector('.page-qa-media-overlay__body');
    body.innerHTML = '';

    if (type === 'youtube') {
        const iframe = document.createElement('iframe');
        iframe.src = withYoutubeAutoplay(href);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', 'allowfullscreen');
        iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        );
        iframe.className = 'page-qa-media-overlay__frame';
        body.appendChild(iframe);
    } else if (type === 'video') {
        const video = document.createElement('video');
        video.src = href;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.className = 'page-qa-media-overlay__video';
        body.appendChild(video);
    } else {
        const img = document.createElement('img');
        img.src = href;
        img.alt = '';
        img.className = 'page-qa-media-overlay__image';
        body.appendChild(img);
    }

    overlay.classList.remove('hidden');
    document.body.classList.add('page-qa-media-open');
}

export function initPageQaMedia() {
    document.addEventListener('click', function (event) {
        const link = event.target.closest('.page-qa__media');

        if (!link || !document.body.contains(link)) {
            return;
        }

        // Only intercept inside public Q&A / FAQ answer content.
        if (!link.closest('.page-qa, .faq-page__answer, .faq-answer, .js-qa-item-answer-view')) {
            return;
        }

        event.preventDefault();
        openMedia(link);
    });
}
